import React from "react";
import SelectBox from "devextreme-react/select-box";
import NumberBox from "devextreme-react/number-box";
import TagBox from "devextreme-react/tag-box";
import CheckBox from "devextreme-react/check-box";

const sortDirections = [
  { id: "asc", name: "Ascending" },
  { id: "desc", name: "Descending" }
];

export default function QuerySetup({
  queryTypes,
  queryType,
  setQueryType,
  fields,
  selectedColumns,
  setSelectedColumns,
  sortField,
  setSortField,
  sortDirection,
  setSortDirection,
  pageSize,
  setPageSize,
  includeTotalCount,
  setIncludeTotalCount
}) {
  return (
    <div className="card">
      <h3>Query Setup</h3>

      <div className="grid-4">

        {/* Query Type */}
        <div className="querysetup_label">
          <label>Query Type</label>
          <SelectBox
            items={queryTypes}
            valueExpr="id"
            displayExpr="name"
            value={queryType}
            onValueChanged={(e) => setQueryType(e.value)}
          />
        </div>

        {/* Sort Field */}
        <div className="querysetup_label">
          <label>Sort Field</label>
          <SelectBox
            items={fields}
            valueExpr="fieldName"
            displayExpr="friendlyLabel"
            value={sortField}
            searchEnabled
            onValueChanged={(e) => setSortField(e.value)}
          />
        </div>

        {/* Sort Direction */}
        <div className="querysetup_label">
          <label>Sort Direction</label>
          <SelectBox
            items={sortDirections}
            valueExpr="id"
            displayExpr="name"
            value={sortDirection}
            onValueChanged={(e) => setSortDirection(e.value)}
          />
        </div>

        {/* Page Size */}
        <div className="querysetup_label">
          <label>Page Size</label>
          <NumberBox
            value={pageSize}
            min={1}
            max={500}
            onValueChanged={(e) => setPageSize(e.value)}
          />
        </div>

      </div>

      {/* Selected Columns */}
      <div className="mt querysetup_label">
        <label>Selected Columns</label>
        <TagBox
          items={fields}
          valueExpr="fieldName"
          displayExpr="friendlyLabel"
          value={selectedColumns}
          showSelectionControls
          applyValueMode="useButtons"
          searchEnabled
          onValueChanged={(e) => setSelectedColumns(e.value)}
        />
      </div>

      {/* Include Total Count */}
      <div className="inline-check">
        <CheckBox
          value={includeTotalCount}
          onValueChanged={(e) => setIncludeTotalCount(e.value)}
        />
        <span>Include total count</span>
      </div>

    </div>
  );
}